/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integration_Retry_Failed_FilesInputs */

const en_integration_retry_failed_files = /** @type {(inputs: Integration_Retry_Failed_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retry failed files`)
};

const es_integration_retry_failed_files = /** @type {(inputs: Integration_Retry_Failed_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reintentar archivos fallidos`)
};

/**
* | output |
* | --- |
* | "Retry failed files" |
*
* @param {Integration_Retry_Failed_FilesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const integration_retry_failed_files = /** @type {((inputs?: Integration_Retry_Failed_FilesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integration_Retry_Failed_FilesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_integration_retry_failed_files(inputs)
	return en_integration_retry_failed_files(inputs)
});